@if (latestConnection$ | async; as latestConnection) {
    <adapt-dashboard-element name="Status">
        <div adapt-dashboard-title-buttons
             *adaptIfAuthorised="EditAllPersonalProfiles">
            @if (editMode) {
                <button adaptButton="editBorderless"
                        data-test="edit-start-date-button"
                        [adaptBlockingClick]="editStartDate"
                        [adaptBlockingClickParam]="latestConnection"></button>
            }
        </div>
        <span>{{ isPendingActive ? "Starting" : "Started" }}
            {{ connectionTypeLabel(latestConnection) }}
            {{ latestConnection.startDate | adaptDate }}</span>
        @if (latestConnection.endDate) {
            <span>, ended {{ latestConnection.endDate | adaptDate }}</span>
        }
    </adapt-dashboard-element>
}
